/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Division } from '../models/division';
import { getDivisions } from '../fn/division/get-divisions';
import { GetDivisions$Params } from '../fn/division/get-divisions';

@Injectable({ providedIn: 'root' })
export class DivisionApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDivisions()` */
  static readonly GetDivisionsPath = '/divisions';

  /**
   * Retrieve all the divisions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDivisions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDivisions$Response(params?: GetDivisions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Division>>> {
    const obs = getDivisions(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all the divisions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDivisions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDivisions(params?: GetDivisions$Params, context?: HttpContext): Observable<Array<Division>> {
    const resp = this.getDivisions$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Division>>): Array<Division> => r.body)
    );
  }

}
